import { RouteConfig } from 'vue-router';
import MswTraining from './components/my-training.vue';

export const training: RouteConfig = {
  path: 'training',
  component: MswTraining,
};
